import { useMantineTheme } from "@mantine/core"
import {
  IconSelector,
  IconChevronUp,
  IconChevronDown,
} from "@tabler/icons-react"
import { SortDirection } from "@tanstack/react-table"

type Props = {
  sortOrder: SortDirection | false
}

export const SortIcon = ({ sortOrder }: Props) => {
  const { colors } = useMantineTheme()
  switch (sortOrder) {
    case "asc":
      return <IconChevronUp color={colors.gray[5]} />
    case "desc":
      return <IconChevronDown color={colors.gray[5]} />
    default:
      return <IconSelector color={colors.gray[5]} />
  }
}
